const styles = `/*////// RESET STYLES //////*/
body, #bodyTable, #bodyCell {
  height: 100% !important;
  margin: 0;
  padding: 0;
  width: 100% !important;
}

table {
  border-collapse: collapse;
}

img, a img {
  border: 0;
  outline: none;
  text-decoration: none;
}

h1, h2, h3, h4, h5, h6 {
  margin: 0;
  padding: 0;
}

p {
  margin: 0;
  padding: 0;
}

/*////// CLIENT-SPECIFIC STYLES //////*/
.ReadMsgBody {
  width: 100%;
}

.ExternalClass {
  width: 100%;
}

.ExternalClass, .ExternalClass p, .ExternalClass span, .ExternalClass font, .ExternalClass td, .ExternalClass div {
  line-height: 100%;
}

table, td {
  mso-table-lspace: 0pt;
  mso-table-rspace: 0pt;
}

#outlook a {
  padding: 0;
}

img {
  -ms-interpolation-mode: bicubic;
  line-height: 0;
}

body, table, td, p, a, li, blockquote {
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
}

h1, h2, h3, h4, h5, h6 {
  text-align: Left;
}

@media only screen and (max-width: 480px) {
  body {
    width: 100% !important;
    min-width: 100% !important;
  }
  table[id=emailBody],
  table[class=flexibleContainer] {
    width: 100% !important;
  }
  img[class=flexibleImage] {
    height: auto !important;
    width: 100% !important;
  }
  table[class=emailButton] {
    width: 100% !important;
  }
  table[class=tinyButton] {
    width: 100% !important;
  }
}`; export default styles;